import { render, staticRenderFns } from "./Suon.vue?vue&type=template&id=9d1bc8ce&"
import script from "./Suon.vue?vue&type=script&lang=js&"
export * from "./Suon.vue?vue&type=script&lang=js&"
import style0 from "./Suon.vue?vue&type=style&index=0&id=9d1bc8ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports